jQuery(document).ready(function($) {
    /*let $els = $('.video-button');
    if($els.length>0) {
        $els.on('click', function() {
            const title = $(this).data('title');
            if(title) {
                const nonce =
                    $(this).data('nonce');

                    $.ajax({
                        type : "post",
                        url : Glob.ajaxurl,
                        data : {action: "videohub_add_play", title, nonce},
                        success: function(response) {
                            console.log(response);
                        },
                        error: function(a,b,c) {
                            console.log([a,b,c]);
                        }
                    });
            }
        });
    } */

    const $video_els = $('.video-hub-video');
    if($video_els.length>0) {
        $video_els.bind("contextmenu",function(){
            return false;
        });
    }

    const $main_video = $('#main-video');
    if($main_video.length>0) {
        $main_video.bind('play', function(e) {
            const title = $(this).data('title');
            if(title) {
                const nonce =
                    $(this).data('nonce');

                $.ajax({
                    type : "post",
                    url : Glob.ajaxurl,
                    data : {action: "videohub_add_play", title, nonce},
                    success: function(response) {
                        console.log(response);
                    },
                    error: function(a,b,c) {
                        console.log([a,b,c]);
                    }
                });
            }
        });
    }

    const $chapters = $('#chapters');
    if($chapters.length>0) {
        const $links = $chapters.find('a');
        $links.on('click', e => {
            e.preventDefault();
            const header =  $('header');
            let time = String($(e.target).data('time'));
            if(time.includes(':')) {
                const parts = time.split(':');
                const minutes = parseInt(parts[0]);
                const seconds = parseInt(parts[1]);
                time = (minutes * 60) + seconds;
            }
            $main_video[0].currentTime = time;
            $main_video[0].play();
            $([document.documentElement, document.body]).animate({
                scrollTop: ($main_video.offset().top - header.height())
            }, 500, false, function() {
                setTimeout(function() {
                    header.addClass('headroom--unpinned')
                },150);
            });
        })
    }
});
